var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marker {\n  background-image: url(" + escape(require("./SimpleMarker.svg")) + ");\n  cursor: pointer;\n  height: 64px;\n  left: -24.5px;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  top: -64px;\n  transform-origin: 24.5 64;\n  width: 49px;\n}\n   ", ""]);

// exports
